import { retrieveLaunchParams } from '@telegram-apps/sdk';

/**
 * Retrieve Telegram start parameter.
 */
export function getStartParam(): string | null {
  try {
    const { startParam } = retrieveLaunchParams();
    if (startParam && typeof startParam === 'string' && startParam.length > 0) {
      return startParam;
    }
  } catch (_e) {
    // ignore: retrieveLaunchParams may throw outside Telegram Mini App
  }
  return null;
}
